"use client";

import { Filter } from "../../../components/meilisearch/Search";

import "instantsearch.css/themes/satellite.css";

const Page = () => {
  return (
    <>
      <div className="pt-10 md:pt-32 pb-24">
        <div className="mx-auto mb-12 px-5 md:px-0">
          <Filter />
        </div>
      </div>
    </>
  );
};

export default Page;
